<template>
  <div class="input-nav">
    <h2 class="input-nav__head">All-in Workspace</h2>
    <div class="progress-bar">

      <label class="progress-bar__label">Enter Inputs:</label>

      <ul class="progress-bar__list"
        :class="progressBarListClass"
      >
        <li class="progress-bar__item">
          <router-link class="progress-bar__link" 
            :to="{ name: 'Utility' }" 
            :class="{ 
              'progress-bar__link--allowed': utility && pricingRequestIsActive,
              'progress-bar__link--complete': utility,
              'progress-bar__link--active': !this.$route.name || this.$route.name === 'Utility',
            }"
          > 
            <template v-if="utility">
              <i class="fa fa-check"></i>
            </template>

            <template v-else>1</template>

          </router-link>
        </li>

        <li class="progress-bar__item">
          <router-link class="progress-bar__link" 
          :to="{ name: 'StartMonth' }" 
          :class="{ 
            'progress-bar__link--allowed': utility && pricingRequestIsActive,
            'progress-bar__link--complete': startMonth,
            'progress-bar__link--active': this.$route.name === 'StartMonth'
          }"
          >
            <template v-if="startMonth">
              <i class="fa fa-check"></i>
            </template>

            <template v-else>2</template>
          </router-link>
        </li>

        <li class="progress-bar__item">
          <router-link class="progress-bar__link" 
          :to="{ name: 'TermLength' }" 
          :class="{ 
            'progress-bar__link--allowed': startMonth && pricingRequestIsActive,
            'progress-bar__link--complete': termLengths && this.$route.name != 'TermLength',
            'progress-bar__link--active': this.$route.name === 'TermLength'
          }"
          >
            <template v-if="termLengths && this.$route.name != 'TermLength'">
              <i class="fa fa-check"></i>
            </template>

            <template v-else>3</template>
          </router-link>
        </li>

        <li class="progress-bar__item">
          <router-link class="progress-bar__link" 
          :to="{ name: 'FacilityProfile' }" 
          :class="{ 
            'progress-bar__link--allowed': termLengths && pricingRequestIsActive,
            'progress-bar__link--complete': facilityCategory || customFacilityProfile,
            'progress-bar__link--active': this.$route.name === 'FacilityProfile' || this.$route.name === 'CustomFacilityProfile'
          }"
          >
            <template v-if="facilityCategory || customFacilityProfile">
              <i class="fa fa-check"></i>
            </template>

            <template v-else>4</template>
          </router-link>
        </li>

        <li class="progress-bar__item">
          <router-link class="progress-bar__link" 
          :to="{ name: 'Volume' }" 
          :class="{ 
            'progress-bar__link--allowed': (facilityCategory && pricingRequestIsActive) || (customFacilityProfile && customFacilityProfileComplete && pricingRequestIsActive),
            'progress-bar__link--complete': volumeComplete,
            'progress-bar__link--active': this.$route.name === 'Volume'
          }"
          >
            <template v-if="volumeComplete">
              <i class="fa fa-check"></i>
            </template>

            <template v-else>5</template>
          </router-link>
        </li>

      </ul>
    </div>

    <ul class="input-nav__items">
      <li class="input-nav__item"
        :class="{ 
          'input-nav__item--active': !this.$route.name || this.$route.name === 'Utility',
          'input-nav__item--allowed': utility && pricingRequestIsActive
        }"
      > 
        <transition 
          name="zoom" 
        > 
          <span class="input-nav__checkmark" v-if="utility" key="checkmark">
            <i class="fa fa-check"></i>
          </span>
          <span class="input-nav__ordinal" v-else key="number">1.</span>
        </transition>

        <router-link class="input-nav__item__link" 
          :to="{ name: 'Utility' }" 
          :class="{ 'input-nav__item__link--allowed': utility && pricingRequestIsActive }"
        >
          <div class="input-nav__item__label">Location</div>
          <transition 
            name="slideRight" 
          > 
            <div class="input-nav__item__value" v-if="utility" v-html="utility"></div>
          </transition> 
        </router-link>
      </li>

      <li class="input-nav__item"
        :class="{ 
          'input-nav__item--active': this.$route.name === 'StartMonth',
          'input-nav__item--allowed': utility && pricingRequestIsActive
        }"
      >
        <transition 
          name="zoom" 
        > 
          <span class="input-nav__checkmark" v-if="startMonth" key="checkmark">
            <i class="fa fa-check"></i>
          </span>
          <span class="input-nav__ordinal" v-else key="number">2.</span>
        </transition>

        <router-link class="input-nav__item__link" 
          :to="{ name: 'StartMonth' }" 
          :class="{ 'input-nav__item__link--allowed': utility && pricingRequestIsActive }"
        >
          <div class="input-nav__item__label">Start Month</div>          
          <transition 
            name="slideRight" 
          > 
            <div class="input-nav__item__value" v-if="startMonth">{{ startMonth }}</div>
          </transition>
        </router-link>
      </li>

      <li class="input-nav__item"
        :class="{ 
          'input-nav__item--active': this.$route.name === 'TermLength',
          'input-nav__item--allowed': startMonth && pricingRequestIsActive
        }"
      >
        <transition 
          name="zoom" 
        > 
          <span class="input-nav__checkmark" v-if="termLengths" key="checkmark">
            <i class="fa fa-check"></i>
          </span>
          <span class="input-nav__ordinal" v-else key="number">3.</span>
        </transition>

        <router-link class="input-nav__item__link" 
          :to="{ name: 'TermLength' }" 
          :class="{ 'input-nav__item__link--allowed': startMonth && pricingRequestIsActive }"
        >
          <div class="input-nav__item__label">Term Lengths</div>
          <transition 
            name="slideRight" 
          > 
            <div class="input-nav__item__value" v-if="termLengths">{{ termLengths }}</div>

          </transition>
        </router-link>
      </li>

      <li class="input-nav__item"
        :class="{ 
          'input-nav__item--active': this.$route.name === 'FacilityProfile' || this.$route.name === 'CustomFacilityProfile',
          'input-nav__item--allowed': termLengths && pricingRequestIsActive
        }"
      >
        <transition 
          name="zoom" 
        > 
          <span class="input-nav__checkmark" v-if="facilityCategory || customFacilityProfile" key="checkmark">
            <i class="fa fa-check"></i>
          </span>
          <span class="input-nav__ordinal" v-else key="number">4.</span>
        </transition>

        <router-link class="input-nav__item__link" 
          :to="{ name: 'FacilityProfile' }" 
          :class="{ 
            'input-nav__item__link--allowed': termLengths && pricingRequestIsActive
          }"
          >
          <div class="input-nav__item__label">Facility Profile</div>

          <transition 
            name="slideRight" 
          > 
            <div class="input-nav__item__value" v-if="customFacilityProfile">Custom Profile</div>
          </transition>

          <transition 
            name="slideRight" 
          > 
            <div class="input-nav__item__value input-nav__item__value--single dev-1" v-if="facilityCategory">
              <category  
                :id="facilityCategory" 
                :key="facilityCategory"
              ></category>
            </div>
          </transition>

          <transition 
            name="slideRight" 
          > 
            <div class="input-nav__item__value input-nav__item__value--single dev-2" v-if="facilityPath">
              <ancestor  
                :id="facilityTree[1]" 
                use-display-name
                :key="facilityTree[1]"
              ></ancestor>
            </div>
          </transition>
          <transition 
            name="slideRight" 
          > 
            <div class="input-nav__item__value dev-3" v-if="facilityPath">
              <ancestor  
                v-for="ancestor in facilityPath" 
                :id="ancestor" 
                use-display-name
                :key="ancestor"
              ></ancestor>

              <br v-if="facilityTree.length > 3">

              {{ facility }}
            </div>
          </transition>
          <transition 
            name="slideRight" 
          > 
            <div class="input-nav__item__value dev-4" v-if="facilityOptions"><small v-html="facilityOptions"></small></div>
          </transition>

          <transition 
            name="slideRight" 
          > 
            <div class="input-nav__item__value" 
              v-if="facilityProfileName"
              v-html="facilityProfileName"
            ></div>
          </transition>
        </router-link>
      </li>

      <li class="input-nav__item"
        :class="{ 
          'input-nav__item--active': this.$route.name === 'Volume',
          'input-nav__item--allowed': 
            (startMonth && termLengths && facilityCategory && customFacilityProfileComplete && pricingRequestIsActive) || 
            (startMonth && termLengths && customFacilityProfile && customFacilityProfileComplete && pricingRequestIsActive)
        }"
      >
        <transition 
          name="zoom" 
        > 
          <span class="input-nav__checkmark" v-if="volumeComplete" key="checkmark">
            <i class="fa fa-check"></i>
          </span>
          <span class="input-nav__ordinal" v-else key="number">5.</span>
        </transition>
        <router-link class="input-nav__item__link" 
          :to="{ name: 'Volume' }" 
          :class="{ 'input-nav__item__link--allowed': 
            (startMonth && termLengths && facilityCategory && customFacilityProfileComplete && pricingRequestIsActive) || 
            (startMonth && termLengths && customFacilityProfile && customFacilityProfileComplete && pricingRequestIsActive) 
          }"
        >
          <div class="input-nav__item__label">Volume</div>
          <transition 
            name="slideRight" 
          > 
            <div class="input-nav__item__value" v-if="volume && !customFacilityProfile">{{ volume }}</div>
          </transition>
          <transition-group 
            name="slideRight" 
          >   
            <div class="input-nav__item__value" 
              v-if="customFacilityVolume && customFacilityProfileComplete"
              v-for="term in customFacilityVolume.terms"
              :key="term.termLength"
            >{{ term.termLength }}-Month Term: {{ formatNumberValue(term.usage, 0) }} kWh</div>
          </transition-group>

          <transition 
            name="slideRight" 
          > 
            <div class="input-nav__item__value" v-if="brokerFee">{{ brokerFee }}</div>
          </transition>
        </router-link>
      </li>

    </ul>
    <div class="input-nav__actions">
      <button class="btn btn-sm"
        :disabled="!allowSave || dataCalculating"
        @click.prevent="savePricingRequest"
      >Save</button>
      <button class="btn btn-sm" 
        :disabled="emptyPricingRequest || dataLoaded" 
        @click.prevent="clearCurrentPricingRequest"
      >Clear</button>
    </div><!--/.input-nav__actions-->
    <div class="input-nav__actions">
      <button class="btn btn-sm" 
        :class="{ 'btn--hover': submitPricingRequestHover }"
        :disabled="!allowPricingRequestSubmission || pricingRequestIssued"
        id="btn-get-pricing"
        v-show="!pricingRequestIssued"
        @click.prevent="getPricing"
        @mouseenter="hoverOnSubmitPricingRequest"
        @mouseleave="hoverOffSubmitPricingRequest"
      >Get Pricing</button> 
      
      <router-link class="btn btn-sm" 
        v-show="pricingRequestIssued"
        :to="{ name: 'PricingData' }" 
        :disabled="this.$route.name === 'PricingData'"
      >Display Output</router-link>
    </div> 
  </div><!--/.input-nav-->
</template>

<script>
import FacilityAncestor from './AncestorLabel.vue'
import _ from 'lodash'
import moment from 'moment'
import swal from 'sweetalert'
import { formatCurrency, formatNumber } from '../../../common/helpers'

export default {
  components: {
    'ancestor': FacilityAncestor,
    'category': FacilityAncestor
  },
  data() {
    return {
      pricingRequestIssued: false
    }
  },
  computed: {
    hasApmProductAccess() {
      const productAccess = this.$store.getters.userProductAccess
      return productAccess['apm']
    },
    currentPricingRequest() {
      return this.$store.getters.currentPricingRequest
    },
    pricingRequestStatus() {
      return this.$store.getters.pricingRequestStatus
    },
    lastLoadedPricingRequest() {
      return this.$store.getters.lastLoadedPricingRequest
    },
    planConfig() {
      return this.$store.getters.planConfig
    },
    savedPricingRequests() {
      return this.$store.getters.savedPricingRequests
    },
    savedRegisteredPricingRequests() {
      if (this.savedPricingRequests.length) {
        let savedRegisteredPricingRequests = this.savedPricingRequests.filter(pricingRequest => pricingRequest.inputs.utility.plan.slug === 'free-registered')
        return savedRegisteredPricingRequests
      }

      return false
    },
    pricingRequestHasBeenEdited() {
      return !_.isEqual(
        _.omit(this.currentPricingRequest, ['facilityProfileName']), 
        _.omit(this.lastLoadedPricingRequest, ['facilityProfileName'])
      )
    },
    pricingRequestIsActive() {
      if (this.startMonthRaw) {
        if (moment(this.startMonthRaw).isBefore()) {
          return false
        } 
      }

      return true
    },
    allowSave() {
      if (!this.hasApmProductAccess) {
        return false
      }

      if (this.currentPricingRequest.utility.plan.slug === 'free') {
        return false
      }

      if (! this.pricingRequestIsActive) {
        return false
      }

      if (this.planConfig.priceRequestSlots && this.savedPricingRequests.length < (this.planConfig.priceRequestSlots)) {
        if (this.utility) {
          return true
        }

        return false
      }

      if (this.utility) {
        return true
      }

      return false
    },
    allowPricingRequestSubmission() {
      if (this.userIsLoggedIn && !this.hasApmProductAccess) {
        return false
      }

      if (!this.userIsLoggedIn && !this.acceptedTermsOfUse) {
        return false
      }

      if (!this.pricingRequestIsActive) {
        return false
      }

      if (this.$route.name === 'CustomFacilityProfile') {
        return false
      }

      if (this.customFacilityProfile && !this.customFacilityProfileComplete) {
        return false
      }

      if (this.utility && this.termLengths) {
        if (this.facilityCategory || this.customFacilityProfile) {

          if (this.customFacilityProfile) {
            if (this.customFacilityVolume) {
              return true
            }
          } else {
            if (this.volume) {
              if (this.currentPricingRequest.volume.brokerFee || this.declineBrokerFee) {
                return true
              }
            } else if (this.customFacilityVolume.brokerFee || this.declineBrokerFee) {
              return true
            }
          }
        }
      }

      return false
    },
    emptyPricingRequest() {
      if (this.utility || this.facility || this.volume || this.startMonth || this.termLengths) {
        return false
      }
      return true
    },
    dataCalculating() {
      if (this.pricingRequestStatus.length && this.pricingRequestStatus !== 'DataCompleted') {
        return true
      }
    },
    dataLoaded() {
      if (this.pricingRequestStatus.length && this.pricingRequestStatus !== 'DataCompleted' && this.pricingRequestStatus !== 'Loaded') {
        return true
      }
    },
    utility() {
      if (this.currentPricingRequest.utilityMeta.name && this.currentPricingRequest.utilityMeta.code) {
        let utility = this.currentPricingRequest.utilityMeta.name + ' - ' + this.currentPricingRequest.utilityMeta.code
        if (this.currentPricingRequest.utilityMeta.municipality || this.currentPricingRequest.utilityMeta.zone) {
          utility += '<br><span>'

          if (this.currentPricingRequest.utilityMeta.municipality) {
            utility += this.currentPricingRequest.utilityMeta.municipality + ', ' + this.currentPricingRequest.utilityMeta.state + ' '
          }

          if (this.currentPricingRequest.utilityMeta.zone) {
            utility += '(Zone ' + this.currentPricingRequest.utilityMeta.zone + ')'
          }

          utility += '</span>'

          return utility
        }
      }

      return false
    },
    facilityType() {
      // Custom profile
      if (this.customFacilityProfile) {
        return this.currentPricingRequest.customFacilityProfileCategory.tier2.facilityType
      }

      // Non-custom profile
      return this.currentPricingRequest.facilityType
    },
    facility() {
      const facilityType = this.facilityType
      if (facilityType) {
        if (facilityType.displayName) {
          return facilityType.displayName
        }
        return facilityType.name
      }
      return false
    },
    facilityCategory() {
      if (this.facilityTree) {
        return this.facilityTree[0]
      }
      return false
    },
    facilityPath() {
      if (this.facilityTree) {
        let tree = this.facilityTree.slice()
        let path = []
        let threshold = 1

        // if (this.facilityAncestorCount > 3) {
        //   threshold = 1
        // }

        for (let i = 0; i < tree.length; ++i) {
          if (i > threshold) {
            path.push(tree[i])
          }
        }

        return path
      }

      return false
    },
    facilityTree() {
      const facilityType = this.facilityType
      if (facilityType.parents) {
        let parents = facilityType.parents.slice()
        parents = parents.reverse()
        return parents
      }

      return false
    },
    facilityAncestorCount() {
      if (this.facilityTree) {
        return this.facilityTree.length
      }

      return 0
    },
    facilityOptions() {
      let facilityCheckboxSelections

      // Custom profile
      if (this.customFacilityProfile) {
        facilityCheckboxSelections = this.currentPricingRequest.customFacilityProfileCategory.tier2.facilityCheckboxOptions

      // Non-custom profile
      } else {
        facilityCheckboxSelections = this.currentPricingRequest.facilityCheckboxSelections
      }

      if (facilityCheckboxSelections) {
        let count = Object.keys(facilityCheckboxSelections).length
        let displayText = ''
        for (let i = 0; i < count; ++i) {
          // Get checkbox option name
          let name = facilityCheckboxSelections[i].displayName ? facilityCheckboxSelections[i].displayName : facilityCheckboxSelections[i].name

          let suboptionName = ''

          if (
            facilityCheckboxSelections[i].suboption && 
            facilityCheckboxSelections[i].suboption.id
          ) {
            // Check for suboption, attach it's name to parent option if present
            suboptionName = ' '
            suboptionName += facilityCheckboxSelections[i].suboption.displayName ? facilityCheckboxSelections[i].suboption.displayName : facilityCheckboxSelections[i].suboption.name
          }

          displayText += name + suboptionName

          if (i != (count - 1)) {
            // Add comma if there are more options
            displayText += ', '

            if ((i+1) % 2 === 0) {
              // Show max of two items per line
              displayText +='<br>'
            }
          }
        }

        return displayText
      }
      return false
    },
    facilityProfileName() {
      return this.currentPricingRequest.facilityProfileName
    },
    customFacilityProfileCategory() {
      return this.currentPricingRequest.customFacilityProfileCategory
    },
    customFacilityProfileCategoryDisplay() {
      if (this.customFacilityProfileCategory.tier1 && this.customFacilityProfileCategory.tier2) {
        let text = ''
        let tier1Name = this.customFacilityProfileCategory.tier1.displayName ? this.customFacilityProfileCategory.tier1.displayName : this.customFacilityProfileCategory.tier1.name

        let tier2Name = null
        if (this.customFacilityProfileCategory.tier2.facilityType) {
          tier2Name = this.customFacilityProfileCategory.tier2.facilityType.displayName ? this.customFacilityProfileCategory.tier2.facilityType.displayName : this.customFacilityProfileCategory.tier2.facilityType.name
        }

        if (tier1Name && tier2Name) {
          text = tier1Name + ': ' + tier2Name
          return text
        }
      }
    },
    customFacilityProfile() {
      let count = Object.keys(this.currentPricingRequest.customFacilityProfile).length
      return count > 0
    },
    customFacilityProfileComplete() {
      return this.$store.getters.customFacilityProfileComplete
    },
    volume() {
      if (! this.currentPricingRequest.volume.amount) {
        return false
      }

      let volume = ''

      switch(this.currentPricingRequest.volume.unit) {
        case 'usage':
          volume = formatNumber(this.currentPricingRequest.volume.amount, 0) + " kWh/Yr"
          break

        case 'total-cost':
          volume = formatCurrency(this.currentPricingRequest.volume.amount, 0) + "/Yr"
          break

        case 'annual-peak':
          volume = formatNumber(this.currentPricingRequest.volume.amount, 0) + " KW"
          break
      }

      return volume
    },
    customFacilityVolume() {
      if (this.currentPricingRequest.customFacilityVolume.terms && this.currentPricingRequest.customFacilityVolume.terms.length) {
        return this.currentPricingRequest.customFacilityVolume
      }

      return false
    },
    volumeComplete() {
      if (!this.customFacilityProfileComplete) {
        return false
      }

      if (this.volume.length || Object.keys(this.customFacilityVolume).length) {

        if (this.declineBrokerFee || this.customFacilityVolume.declineBrokerFee) {
          return true

        } else if (
          this.currentPricingRequest.volume.brokerFee || 
          this.currentPricingRequest.volume.declineBrokerFee ||
          this.currentPricingRequest.customFacilityVolume.brokerFee
        ) {
          return true
        }
      }

      return false
    },
    declineBrokerFee() {
      return this.$store.getters.declineBrokerFee
    },
    brokerFee() {
      let brokerFee = ''

      if (
        this.currentPricingRequest.volume.displayAdjustmentInNav &&
        this.currentPricingRequest.volume.brokerFee
      ) {
        brokerFee = 'Adjustment: $' + this.currentPricingRequest.volume.brokerFee.replace('$','') + '/kWh'

      } else if (
        this.currentPricingRequest.customFacilityVolume.displayAdjustmentInNav &&
        this.currentPricingRequest.customFacilityVolume.brokerFee
      ) {
        brokerFee = 'Adjustment: $' + this.currentPricingRequest.customFacilityVolume.brokerFee.replace('$','') + '/kWh'
      }

      return brokerFee
    },
    startMonthRaw() {
      if (this.currentPricingRequest.startMonth) {
        return moment(this.currentPricingRequest.startMonth)
      }
    },
    startMonth() {
      if (this.startMonthRaw) {
        return this.startMonthRaw.format('MMM YYYY')
      }

      return false
    },
    termLength() {
      return this.$store.getters.termLength
    },
    activeTerms() {
      var activeTerms = this.termLength
      activeTerms = activeTerms.filter(function(item) {
        return item.value != ''
      })
      return activeTerms
    },
    activeTermLengthCount() {
      // The number of terms set in the store
      return Object.keys(this.activeTerms).length
    },
    termLengths() {
      if (this.activeTermLengthCount < 1) {
        return false
      }

      let displayText = ''
      
      switch(this.activeTermLengthCount) {
        case 1: 
          displayText = this.activeTerms[0].value
          break;
        case 2:
          displayText = this.activeTerms[0].value + ' & ' + this.activeTerms[1].value
          break;
        case 3:
          displayText = this.activeTerms[0].value + ', ' + this.activeTerms[1].value + ', & ' + this.activeTerms[2].value
          break;
      }

      let lastTerm = displayText+''
      lastTerm = lastTerm.split(" ")

      if (lastTerm[lastTerm.length - 1] === '1') {
        displayText += ' Month'
      } else {
        displayText += ' Months'
      }

      return displayText
    },
    submitPricingRequestHover() {
      return this.$store.getters.submitPricingRequestHover
    },
    progressBarListClass() {
      
      if (this.$route.name === 'StartMonth')
        return 'progress-bar__list--1'

        switch(this.$route.name) {
          case 'StartMonth':
            return 'progress-bar__list--1'
            break

          case 'TermLength':
            return 'progress-bar__list--2'
            break

          case 'FacilityProfile':
          case 'CustomFacilityProfile':
            return 'progress-bar__list--3'
            break

          case 'Volume':
          case 'GetPricing':
            return 'progress-bar__list--4'
            break
        }
    },
    acceptTermsOfUse() {
      return this.$store.getters.acceptTermsOfUse
    },
    userIsLoggedIn() {
      return this.$store.state.auth.user.id && 
             this.$store.state.auth.plan && 
             this.$store.state.auth.plan.slug != 'free'
    },
    acceptedTermsOfUse() {
      return this.acceptTermsOfUse == true
    }
  },
  methods: {
    /**
     * Utility function to get the difference
     * between two objects.
     */
    // getDiff(obj1, obj2) {
    //   if (obj1 == undefined || obj2 == undefined) {
    //     console.log('undefined')
    //     return
    //   }

    //   const diff = Object.keys(obj1).reduce((result, key) => {
    //     if (!obj2.hasOwnProperty(key)) {
    //       result.push(key);
    //     } else if (_.isEqual(obj1[key], obj2[key])) {
    //       const resultKeyIndex = result.indexOf(key);
    //       result.splice(resultKeyIndex, 1);
    //     }
    //     return result;
    //   }, Object.keys(obj2));

    //   return diff;
    // },
    formatNumberValue(val, decimals) {
      return formatNumber(val, decimals)
    },
    clearCurrentPricingRequest() {
      this.$store.dispatch('clearCurrentPricingRequest')
      this.$store.dispatch('clearAllFacilityData')
    },
    savePricingRequest() {
      let self = this
      let utilityPlanSlug = this.currentPricingRequest.utility.plan.slug

      if (utilityPlanSlug === 'free-registered' && this.savedRegisteredPricingRequests.length) {

        if (this.pricingRequestHasBeenEdited) {
          var swalContent = document.createElement('div');
          swalContent.innerHTML = '<p class="alerts message alerts--no-brdr alerts--close-btn">This action will save one or more changes to your current set of saved inputs. Do you want to continue?</p>';

          swal({
            content: swalContent,
            closeOnEsc: false,
            closeOnClickOutside: false,
            buttons: {
              cancel: {
                text: "Don't Save",
                value: null,
                visible: true,
                className: "",
                closeModal: true,
              },
              confirm: {
                text: "Save",
                value: true,
                visible: true,
                className: "",
                closeModal: true
              }
            }
          }).then((result) => {
            if (result) {
              self.$store.dispatch('updatesavedPricingRequest') 
            }
          }).catch(function() {})

          return
        }

        self.$store.dispatch('updatesavedPricingRequest')
        return
      }

      // If creating a request using a custom profile, we'll need to 
      // get a reference to the custom-only "Save" button.
      const customProfileSaveButton = document.getElementById('btn-save-custom')

      // Has this config been previously saved?...
      if (this.currentPricingRequest.savedPricingRequestId) {
        let swalContent = document.createElement('div');
        swalContent.innerHTML = '<p class="alerts message alerts--no-brdr alerts--close-btn mrgn-btm-0">Do you want to update your current request or save it as a new price request?</p> <p class="alerts message alerts--no-brdr error content-xxsm mrgn-btm-0">Selecting the <b>Update</b> button will replace all currently calculated prices, including historical pricing, with newly calculated values. This action is not reversible.</p>';

        swal({
          content: swalContent,
          closeOnEsc: false,
          closeOnClickOutside: false,
          className: 'swal--wide',
          buttons: {
            cancel: {
              text: "Save as New",
              value: null,
              visible: true,
              className: "swal-button--cancel--blue",
              closeModal: true,
            },
            confirm: {
              text: "Update",
              value: true,
              visible: true,
              className: "",
              closeModal: true
            },
            close: {
              text: "Cancel",
              value: 'close',
              visible: true,
              className: "",
              closeModal: true
            }
          }
        }).then((result) => {

          if (result && result === 'close') {
            return
          
          } else if (result) {
            // Why?
            if (customProfileSaveButton) {
              customProfileSaveButton.click()
            }

            self.$store.dispatch('updatesavedPricingRequest')        
          
          } else {
            // Why?
            if (customProfileSaveButton) {
              customProfileSaveButton.click()
            }

            self.$store.dispatch('savecurrentPricingRequest') 
          }
        }).catch(function(action) {
          if (action === 'close') {
            return
          } 
        })

      // ...otherwise create a new price request.
      } else {
        // Why?
        if (customProfileSaveButton) {
          customProfileSaveButton.click()
        }

        self.$store.dispatch('savecurrentPricingRequest') 
      }
    },
    reverse (a) {
      let b = [], 
          counter = 0
      for (let i = a.length-1; i >= 0; i -= 1) {
        b[counter] = a[i]
        counter += 1
      }
      return b
    },
    hoverOnSubmitPricingRequest() {
      this.$store.dispatch('hoverOnSubmitPricingRequest')
    },
    hoverOffSubmitPricingRequest() {
      this.$store.dispatch('hoverOffSubmitPricingRequest')
    },
    getPricing() {
      let self = this
      let utilityPlanSlug = this.currentPricingRequest.utility.plan.slug

      if (utilityPlanSlug === 'free') {
        this.issuePricingRequest()
      }

      if (utilityPlanSlug === 'free-registered' && this.savedRegisteredPricingRequests.length) {

        if (this.pricingRequestHasBeenEdited) {
          let swalContent = document.createElement('div');
          swalContent.innerHTML = '<p class="alerts message alerts--no-brdr alerts--close-btn">This action will save one or more changes to your current set of saved inputs. Do you want to continue?</p>';

          swal({
            content: swalContent,
            closeOnEsc: false,
            closeOnClickOutside: false,
            buttons: {
              cancel: {
                text: "Cancel",
                value: null,
                visible: true,
                className: "",
                closeModal: true,
              },
              confirm: {
                text: "Yes",
                value: true,
                visible: true,
                className: "",
                closeModal: true
              }
            }
          }).then((result) => {
            
            if (result) {
              self.$store.dispatch('updatesavedPricingRequest', true)

              // This causes duplicate pricing requests to be made 
              // under certain situations, but tracing it and fixing 
              // the code while avoiding breaking other things has 
              // proved to be a nightmare (and is thus uncompleted).
              // So, a check was added to the backend to prevent 
              // duplicate requests from being made.
              setTimeout(() => {
                self.issuePricingRequest()
              }, 500)
            }
          })

          return
        }
        
        this.issuePricingRequest()
        return
      }

      // Has this config been previously saved?
      if (this.currentPricingRequest.savedPricingRequestId) {
        let swalContent = document.createElement('div')
        swalContent.innerHTML = '<p class="alerts message alerts--no-brdr alerts--close-btn mrgn-btm-0">Do you want to update your current request or save it as a new price request?</p> <p class="alerts message alerts--no-brdr error content-xxsm mrgn-btm-0">Selecting the <b>Update</b> button will replace all currently calculated prices, including historical pricing, with newly calculated values. This action is not reversible.</p>'

        swal({
          content: swalContent,
          closeOnEsc: false,
          className: 'swal--wide',
          closeOnClickOutside: false,
          buttons: {
            cancel: {
              text: "Save as New",
              value: null,
              visible: true,
              className: "swal-button--cancel--blue",
              closeModal: true,
            },
            confirm: {
              text: "Update",
              value: true,
              visible: true,
              className: "",
              closeModal: true
            },
            close: {
              text: "Cancel",
              value: 'close',
              visible: true,
              className: "",
              closeModal: true
            }
          }

        }).then((result) => {

          if (result && result === 'close') {
            return

          } else if (result) {
            self.$store.dispatch('updatesavedPricingRequest', true)

            setTimeout(() => {
              self.issuePricingRequest()
            }, 500)
          } else {
            self.$store.dispatch('savecurrentPricingRequest', true) 
          }
          
        }).catch((action) => {
          if (action === 'close') {
            return
          } 
        })

      } else {
        // may need to fetch saved requests after the initial generation...
        this.$store.dispatch('savecurrentPricingRequest', true) 
      }
    },
    issuePricingRequest() {
      this.pricingRequestIssued = true
      this.$store.dispatch('getPricing')
    }
  },
  watch: {
    pricingRequestHasBeenEdited(bool) {
      if (bool) {
        this.$store.dispatch('clearAllOutputData')
        this.pricingRequestIssued = false
        this.$store.dispatch('hoverOffSubmitPricingRequest')
      }
    },
    pricingRequestStatus(status) {
      if (status === 'Pending' || status === 'Loaded') {
        this.pricingRequestIssued = true
      }
    }
  },
  beforeUpdate() {
    if (this.pricingRequestStatus === 'Pending' || this.pricingRequestStatus === 'Loaded') {
      this.pricingRequestIssued = true
    } else if (!this.pricingRequestStatus) {
      this.pricingRequestIssued = false
    } 
  }
}
</script>
